// extracted by mini-css-extract-plugin
export default {"verified":"t2qc6","icon":"z41nZ"};